import React from 'react'

import { Icon, Button, ArrowRight } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import PrintCategoriesIcon from 'Pods/Shared/Icons/PrintCategories'

function SectionHeader({ title, description, buttonText, buttonHref, badgeText = 'categories' }) {
  return (
    <div className="categories-section__header">
      <div className="categories-section__badge">
        <PrintCategoriesIcon />
        <span className="categories-section__badge-text">{badgeText}</span>
      </div>
      <div className="categories-section__title-section">
        <h2 className="categories-section__title">{title}</h2>
        <span className="categories-section__description">{description}</span>
      </div>
      <Button href={buttonHref} trailIcon={<Icon svgComponent={ArrowRight} size="small" />}>
        {buttonText}
      </Button>
    </div>
  )
}

SectionHeader.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  buttonText: string.isRequired,
  buttonHref: string.isRequired,
  badgeText: string,
}

export default SectionHeader
